
import { Options, Prop, Vue } from "vue-property-decorator";

@Options({
  name: "MyProfile",
})
export default class MyProfile extends Vue {}
